import {
  Button,
  BUTTON_VARIANT_PRIMARY,
  BUTTON_VARIANT_SECONDARY,
  Modal,
  MODAL_SIZE_MD,
  ModalBody,
  ModalFoot,
  ModalHead
} from 'mailup-web-components'
import PropTypes from 'prop-types'

import { useIntl } from 'react-intl'

export const ModalActionCopyWarning = ({
  show,
  handleCancel,
  handleConfirm
}) => {
  const intl = useIntl()

  return (
    <Modal
      data-mu-test='modal-copy-warning'
      show={show}
      showClose
      onClose={handleCancel}
      closeOnOverlayClick
      size={MODAL_SIZE_MD}
    >
      <ModalHead
        title={intl.formatMessage({
          id: 'Load.WelcomeSeries.existWelcomeSeriesWorkflowModalTitleNew'
        })}
      />
      <ModalBody>
        {intl.formatMessage({
          id: 'Load.AutomationWorkflow.existWelcomeSeriesWorkflowModalDescr'
        })}
      </ModalBody>
      <ModalFoot>
        <Button
          kind={BUTTON_VARIANT_SECONDARY}
          onClick={handleCancel}
          data-mu-test='button-cancel'
        >
          {intl.formatMessage({ id: 'Load.Common.Close' })}
        </Button>
        <Button
          kind={BUTTON_VARIANT_PRIMARY}
          onClick={handleConfirm}
          data-mu-test='button-confirm'
        >
          {intl.formatMessage({
            id: 'Load.Common.Modify'
          })}
        </Button>
      </ModalFoot>
    </Modal>
  )
}

ModalActionCopyWarning.propTypes = {
  show: PropTypes.bool,
  handleCancel: PropTypes.func,
  handleConfirm: PropTypes.func
}
